// src/components/ProductTour.jsx
// Drop-in onboarding spotlight tour.
//
// MOUNT POINT, in CustomerDashboard.jsx, place immediately after <ToastContainer>:
//
//   import ProductTour from "../../components/ProductTour";
//
//   return (
//     <>
//       <style>{styles}</style>
//       <div className={`dash-root${darkMode ? " dark" : ""}`}>
//         <ToastContainer toasts={toasts} />
//         <ProductTour />          {/* ← RIGHT HERE */}
//         ...rest of dashboard...
//
// WHY HERE: dash-root is a normal block (no position:relative), so both the
// fixed overlay and the fixed tooltip anchor to the viewport correctly.
// Rendering before the sticky header means z-index 9000 reliably sits above
// everything including the app-banner and dash-header.
//
// IDs to add to CustomerDashboard filter fields:
//   <div className="field-group" id="tour-search">      , Search
//   <div className="field-group" id="tour-period">      , Period
//   <div className="field-group" id="tour-pipeline">    , Pipeline Stage
//   <div className="field-group" id="tour-sic">         , SIC Code
//   <div className="field-group" id="tour-enrichment">  , Enrichment
//   <div className="field-group" id="tour-date-range">  , Date Range
//   <div className="field-group" id="tour-modified-by"> , Modified By (admin only, safe to omit)
//
// Re-trigger during dev: localStorage.removeItem("axo_tour_done")

import React from "react";
import SpotlightTour from "./SpotlightTour";

// Customer dashboard (Overview) tour. Mount ONLY while the Overview section is
// visible, its targets don't exist on the Sales section.
const STORAGE_KEY = "axo_tour_done";
// A step with targetId: null renders a centred welcome card (no spotlight).
const STEPS = [
  {
    targetId: null,
    title: "Welcome to your dashboard",
    body: "Let's take 30 seconds to show you the filters, the fastest way to zero in on the right companies.",
  },
  {
    targetId: "tour-search",
    title: "Find a company instantly",
    body: "Type any name or company number to jump straight to a record you already know.",
  },
  {
    targetId: "tour-period",
    title: "Quick time window",
    body: "Snap to today or the last 7 days, great for catching the freshest additions.",
  },
  {
    targetId: "tour-pipeline",
    title: "Pipeline stage",
    body: "Filter by where a signal sits, new, contacted, qualified, won, or lost.",
  },
  {
    targetId: "tour-sic",
    title: "Target by industry",
    body: "Know the SIC code you're after? Drop it in here and surface only those companies.",
  },
  {
    targetId: "tour-enrichment",
    title: "Enrichment status",
    body: "Split the list between companies with contact data pulled in and those still waiting.",
  },
  {
    targetId: "tour-date-range",
    title: "Registration window",
    body: "Set an exact from/to range to zero in on companies registered during a specific period.",
  },
  {
    targetId: "tour-modified-by",
    title: "Your team's activity",
    body: "Pick a team member to see only the companies they've already touched.",
  },
];

const ProductTour = () => (
  <SpotlightTour
    steps={STEPS}
    storageKey={STORAGE_KEY}
    counterLabel={(n, total) => `Filter ${n} of ${total}`}
    waitForId="tour-search"
  />
);

export default ProductTour;
